import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/admin/transactions/multi-upload-file",
		component: lazy(() => import("./TransactionsStateMultiUploadFilePage")),
	},
]);
